import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'contributions',
        loadChildren: () => import('./pages/contributions/contributions.module').then(m => m.ContributionsModule)
      },
      {
        path: 'pledges',
        loadChildren: () => import('./pages/pledges/pledges.module').then(m => m.PledgesModule)
      },
      {
        path: 'setup',
        loadChildren: () => import('./pages/setup/setup.module').then(m => m.SetupModule)
      },
      {
        path: 'statements',
        loadChildren: () => import('./pages/statements/statements.module').then(m => m.StatementsModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./pages/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'training',
        loadChildren: () => import('./pages/training/training.module').then(m => m.TrainingModule)
      },
      {
        path: 'gift-reporter-admin',
        loadChildren: () => import('./pages/gift-reporter-admin/gift-reporter-admin.module').then(m => m.GiftReporterAdminModule)
      },
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        loadChildren: () => import('./pages/auth/login/login.module').then(m => m.LoginModule)
      },
      {
        path: 'reset-password',
        loadChildren: () => import('./pages/auth/reset-password/reset-password.module').then(m => m.ResetPasswordModule)
      },
      {
        path: 'statement-view',
        loadChildren: () => import('./pages/auth/statement-view/statement-view.module').then(m => m.StatementViewModule)
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
